var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPaciente(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".icon_paciente_svg__a{fill:none}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "icon_paciente_svg__a",
    d: "M0 0h40v40H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.475 20.714c-5.028 0-7.956.559-9.494 2.286a8.222 8.222 0 00-1.9 3.429 21.38 21.38 0 000 3.429 1.172 1.172 0 00.949 1.143h19.939a1.172 1.172 0 00.949-1.143 21.377 21.377 0 000-3.429 8.322 8.322 0 00-1.9-3.429c-1.533-1.74-3.507-2.286-8.543-2.286z",
    stroke: "#797979"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.334 7)",
    stroke: "#2196f3"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "icon_paciente_svg__a",
    cx: 6,
    cy: 6,
    r: 5.5
  })))));
}
export default __webpack_public_path__ + "static/media/icon_paciente.3607a0b3.svg";
export { SvgIconPaciente as ReactComponent };